<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}' style="max-height: 30px">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Главная</a></li>
        <li><a routerLink="/courses">Курсы</a></li>
        <li>{{currentCourse.title}}</li>
      </ul>
      <h2>Курсы</h2>
    </div>
  </div>
</div>

<section class="courses-details-area pt-100 pb-70">
  <div class="container">
    <div class="courses-details-header">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <div class="courses-title">
            <h2>{{currentCourse.title}}</h2>
            <p>{{currentCourse.brief}}</p>
          </div>

          <div class="courses-meta">
            <ul>
              <li>
                <i class='bx bx-folder-open'></i>
                <span>Категория</span> <a>{{currentCourse.category}}</a>
              </li>
              <li>
                <i class='bx bx-group'></i>
                <span>Студенты</span> <a>{{currentCourse.enrolled}}</a>
              </li>
              <li>
                <i class='bx bx-calendar'></i>
                <span>Последнее обновление</span>
                <a>{{currentCourse.updatedAt | date :'dd/MM/yyyy'}}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="courses-price">
            <div class="courses-review">
              <div class="review-stars">
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
              </div>
              <span class="reviews-total d-inline-block">(5)</span>
            </div>
            <div class="price">{{currentCourse.price}}сом</div>
            <a class="default-btn" routerLink="/courses/{{currentCourse?._id}}"><i
              class='bx bx-paper-plane icon-arrow before'></i><span class="label">Начать</span><i
              class="bx bx-paper-plane icon-arrow after"></i></a>
            <!-- <a routerLink="/course-details" class="default-btn"><i class='bx bx-paper-plane icon-arrow before'></i><span class="label">Buy Course</span><i class="bx bx-paper-plane icon-arrow after"></i></a> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <div class="courses-details-image text-center">
          <img alt="image" src="{{currentCourse.imgUrl}}">
        </div>

        <div class="courses-details-desc">
          <h3>Чему вы научитесь</h3>
          <div class="why-you-learn">
            <p><span [innerHTML]="currentCourse.whatYouWillLearn"></span></p>
<!--            <ul>-->
<!--              <li>-->
<!--                <span>-->
<!--                    <i class='bx bx-check'></i>-->
<!--                    Become an expert in Statistics-->
<!--                </span>-->
<!--              </li>-->
<!--            </ul>-->
          </div>
          <h3>Описание</h3>
          <p><span [innerHTML]="currentCourse.description"></span></p>
          <h3>Для кого этот курс:</h3>
          <p><span [innerHTML]="currentCourse.whoThisCourseIsFor"></span></p>
          <h3>Познакомьтесь с вашим преподавателем</h3>
          <div class="courses-author">
            <div class="author-profile-header"></div>
            <div class="author-profile">
              <div class="author-profile-title">
                <img alt="image" class="shadow-sm rounded-circle" src="{{currentCourse.instructor?.imgUrl || 'assets/img/user1.jpg'}}">
                <div class="author-profile-title-details d-flex justify-content-between">
                  <div class="author-profile-details">
                    <h4>{{currentCourse.instructor?.fullName}}</h4>
                    <span class="d-block">{{currentCourse.instructor?.skills}}</span>
                  </div>
                </div>
              </div>
              <p>{{currentCourse.instructor?.brief}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="courses-sidebar-information">
          <ul>
            <li>
              <span><i class='bx bx-group'></i> Студенты:</span> {{currentCourse.enrolled}}
            </li>
            <li>
              <span><i class='bx bx-time'></i> Длительность:</span> {{currentCourse.courseLength}} (месяц)
            </li>
            <li>
              <span><i class='bx bx-tachometer'></i> Нагрузка:</span> 2–5 часов в неделю
            </li>
            <li>
              <span><i class='bx bxs-institution'></i> Организация:</span>
              <a class="d-inline-block">Секом</a>
            </li>
            <li>
              <span><i class='bx bxs-graduation'></i> Категория:</span> {{currentCourse.category}}
            </li>
            <li>
              <span><i class='bx bx-atom'></i> Экзамен:</span> Есть
            </li>
            <li>
              <span><i class='bx bxs-badge-check'></i> Уровень:</span> {{currentCourse.level || 'Средний'}}
            </li>
            <li>
              <span><i class='bx bx-support'></i> Язык:</span> {{languagesMap[currentCourse.language]}}
            </li>
<!--            <li>-->
<!--              <span><i class='bx bx-certification'></i> Сертификат:</span> Есть-->
<!--            </li>-->
          </ul>
        </div>

        <div class="courses-sidebar-syllabus">
          <h3>Учебная программа</h3>
          <span class="chapter">Главы</span>
          <div class="courses-list">
            <ul>
              <span *ngFor="let chapter of currentCourse.chapters; let i=index">
              <li>
                <a routerLink="/courses/{{currentCourse._id}}">
                  <span class="number">{{i + 1}}.</span> {{chapter.title}}
                  <span *ngIf="i===0" class="free-lesson">Бесплатно</span>
                </a>
              </li>
              <li>Экзамен</li>
              </span>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
